import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { Activity, FormType } from '../models/Activity';

export default class ActivityApi {

    private http: HTTPClient;
    private sitiagriRoot: string;

    constructor(http: HTTPClient, sitiagriRoot: string) {
        this.http = http;
        this.sitiagriRoot = sitiagriRoot;
    }

    public async getActivitiesTypeByForm(pk_cuaa: number, brgTypeId: number, formType: number): Promise<Activity[]> {
        let count = 0;
        let totalCount = 0;
        const params = {
            by_brg_type: brgTypeId,
            offset: 0, 
            count: 25   
        }
        const activities: Activity[] = [];

        do {
            const res = await this.http.get(`${this.sitiagriRoot}/v1/plots/subjects/${pk_cuaa}/form_types/${formType}/dictionary_generic_activities`, {params});
            totalCount = res.data.totalcount;
            count += res.data.records.length;
            params.offset += res.data.records.length;
            activities.push(...res.data.records);
        } while (count < totalCount);

        return activities;
    }


    public async getFormTypes(pk_cuaa: number): Promise<FormType[]> {
        const res = await this.http.get(`${this.sitiagriRoot}/v1/plots/subjects/${pk_cuaa}/form_types`)
        return res.data.records;
    }


}
